(() => {
  const root = document.querySelector('.dvah');
  if (!root || root.dataset.ready) return;
  root.dataset.ready = 'true';
  const $ = (s) => root.querySelector(s);
  const labels = JSON.parse($('#dvah-labels').textContent);
  const heroFilm = $('#hero-film');
  const heroToggle = $('.hero-film-toggle');
  if (heroFilm && heroToggle) {
    const reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
    let wantsMotion = !reducedMotion.matches;
    let heroInView = true;
    heroFilm.muted = true;
    heroFilm.defaultMuted = true;
    heroToggle.hidden = false;
    const updateHeroControl = () => {
      heroToggle.textContent = heroFilm.paused ? heroToggle.dataset.playLabel : heroToggle.dataset.pauseLabel;
    };
    const syncHeroPlayback = () => {
      if (wantsMotion && heroInView && !document.hidden) {
        heroFilm.play().catch(updateHeroControl);
      } else {
        heroFilm.pause();
      }
      updateHeroControl();
    };
    heroFilm.addEventListener('playing', () => {
      heroFilm.classList.add('is-ready');
      updateHeroControl();
    });
    heroFilm.addEventListener('pause', updateHeroControl);
    heroFilm.addEventListener('error', () => {
      heroFilm.classList.remove('is-ready');
      heroToggle.hidden = true;
    });
    heroToggle.addEventListener('click', () => {
      wantsMotion = heroFilm.paused;
      syncHeroPlayback();
    });
    reducedMotion.addEventListener('change', () => {
      wantsMotion = !reducedMotion.matches;
      syncHeroPlayback();
    });
    document.addEventListener('visibilitychange', syncHeroPlayback);
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(entries => {
        heroInView = entries[0].isIntersecting;
        syncHeroPlayback();
      }, { threshold: 0.1 }).observe($('.hero'));
    }
    syncHeroPlayback();
  }

  const state = { pieces: [], category: 'All', origin: 'Undecided', savedOnly: false, visible: 12, active: null, inquiry: null, returnFocus: null, previousHash: '' };
  let saved;
  try { saved = new Set(JSON.parse(localStorage.getItem('dvah_inspiration_v1') || '[]')); } catch { saved = new Set(); }
  const esc = (s) => String(s ?? '').replace(/[&<>"']/g, (c) => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
  const dialog = $('#piece-dialog');
  let toastTimer;
  function toast(text) { $('.toast').textContent = text; $('.toast').classList.add('visible'); clearTimeout(toastTimer); toastTimer = setTimeout(() => $('.toast').classList.remove('visible'), 3200); }
  function saveState() { try { localStorage.setItem('dvah_inspiration_v1', JSON.stringify([...saved])); } catch {} }
  function updateSaved() {
    $('[data-saved-count]').textContent = saved.size;
    $('[data-action="saved"]').setAttribute('aria-pressed', String(state.savedOnly));
    root.querySelectorAll('[data-save]').forEach((b) => { const selected = saved.has(b.dataset.save); b.setAttribute('aria-pressed',String(selected)); b.setAttribute('aria-label',(selected ? labels.remove : labels.save) + ': ' + b.dataset.title); b.textContent = selected ? '♥' : '♡'; });
    if(state.active) { $('[data-detail-save]').textContent = saved.has(state.active.id) ? labels.remove : labels.save; $('[data-detail-save]').setAttribute('aria-pressed', String(saved.has(state.active.id))); }
    updateInquiry();
  }
  function updateInquiry() {
    const ids = new Set([...saved, ...(state.inquiry ? [state.inquiry] : [])]);
    const refs = state.pieces.filter(p => ids.has(p.id)).map(p => `${p.name} (${p.reference})`);
    $('#inquiry-pieces').value = refs.length ? refs.join('; ') : labels.general;
  }
  function toggleSave(id) { const wasSaved = saved.has(id); wasSaved ? saved.delete(id) : saved.add(id); saveState(); updateSaved(); if(state.savedOnly) render(); toast(wasSaved ? labels.removed : labels.added); }
  function card(p, i) {
    return `<article class="piece-card"><button class="piece-image-link" data-open="${esc(p.id)}" aria-label="${esc(labels.view + ' ' + p.name)}"><img src="${esc(p.image)}" alt="${esc(p.name + ', ' + p.metal)}" loading="lazy" width="1000" height="1000">${p.sideImage ? '<img class="piece-hover-image" src="'+esc(p.sideImage)+'" alt="" aria-hidden="true" loading="lazy" width="1000" height="1000">' : ''}<span class="image-index">${String(i+1).padStart(2,'0')}</span>${p.video ? '<span class="film-indicator">▷ 360°</span>' : ''}</button><button class="card-save" data-save="${esc(p.id)}" data-title="${esc(p.name)}" aria-pressed="false" aria-label="${esc(labels.save + ': ' + p.name)}">♡</button><div class="card-copy"><div><h3><button data-open="${esc(p.id)}">${esc(p.name)}</button></h3><p>${esc(p.metal)}${Number(p.carats)>0 ? ' · '+esc(p.carats)+' ct' : ''}</p></div><button class="card-arrow" data-open="${esc(p.id)}" aria-label="${esc(labels.view + ' ' + p.name)}">↗</button></div></article>`;
  }
  function render() {
    const pieces = state.pieces.filter(p => (state.category === 'All' || p.category === state.category) && (!state.savedOnly || saved.has(p.id)));
    $('[data-piece-grid]').innerHTML = pieces.slice(0,state.visible).map(card).join('');
    $('[data-result-count]').textContent = `${pieces.length} ${state.savedOnly ? labels.saved_designs : labels.designs}`;
    $('.show-more').hidden = pieces.length <= state.visible;
    $('.empty-state').hidden = pieces.length !== 0;
    $('.reset-filter').hidden = !state.savedOnly && state.category === 'All';
    root.querySelectorAll('[data-category]').forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.category === state.category)));
    updateSaved();
  }
  function changeOrigin(origin) { state.origin = origin; ['#diamond-choice','#inquiry-origin','#detail-origin'].forEach(s=>$(s).value=origin); }
  function openPiece(id, updateHash = true) {
    const p = state.pieces.find(p => p.id === id); if (!p) return;
    if (!dialog.open) { state.returnFocus = document.activeElement; state.previousHash = location.hash.startsWith('#piece/') ? '#collection' : location.hash; }
    state.active = p;
    $('#piece-title').textContent = p.name;
    $('[data-detail-category]').textContent = p.category;
    $('[data-detail-description]').textContent = p.description;
    const video=$('[data-detail-video]'); video.pause();video.removeAttribute('src');video.load();video.hidden=true;video.poster=p.image;
    const photos=p.images || [{url:p.image,view:'front'}];
    $('[data-gallery-thumbnails]').innerHTML=photos.map((photo,i)=>'<button type="button" data-photo="'+i+'" aria-pressed="false"><img src="'+esc(photo.url)+'" alt="" width="70" height="70"><span>'+esc(photo.view==='view_number'?labels.view_number+' '+(i+1):labels[photo.view])+'</span></button>').join('')+(p.video?'<button type="button" data-media="video" aria-pressed="false"><span class="gallery-film-icon" aria-hidden="true">▷</span><span>'+esc(labels.film)+'</span></button>':'');
    selectPhoto(0);
    const specs=[[labels.carats,Number(p.carats)>0 ? p.carats+' ct' : ''],[labels.metal,p.metal],[labels.shape,p.shape],[labels.setting,p.setting],[labels.color,p.color],[labels.clarity,p.clarity]].filter(([k,v])=>v);
    $('[data-detail-specs]').innerHTML=specs.map(([k,v])=>`<dt>${esc(k)}</dt><dd>${esc(v)}</dd>`).join('');
    $('[data-detail-reference]').textContent=labels.reference+' '+p.reference;
    $('#detail-origin').value=state.origin;
    if(!dialog.open)dialog.showModal();
    if(updateHash)history.replaceState(null,'','#piece/'+encodeURIComponent(id));
    updateSaved();
  }
  function closePiece() { if(dialog.open)dialog.close(); }
  dialog.addEventListener('close',()=>{ $('[data-detail-video]').pause(); if(location.hash.startsWith('#piece/'))history.replaceState(null,'',location.pathname+location.search+(state.previousHash||'#collection')); state.active=null; if(state.returnFocus?.isConnected)state.returnFocus.focus({preventScroll:true}); });
  $('.dialog-close').addEventListener('click',closePiece);
  dialog.addEventListener('click',e=>{if(e.target===dialog){const r=dialog.getBoundingClientRect();if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom)closePiece();}});
  root.addEventListener('click',e=>{
    const opener=e.target.closest('[data-open]');if(opener)openPiece(opener.dataset.open);
    const save=e.target.closest('[data-save]');if(save)toggleSave(save.dataset.save);
    const category=e.target.closest('[data-category]');if(category){state.category=category.dataset.category;state.visible=12;render();}
  });
  $('.show-more').addEventListener('click',()=>{state.visible+=12;render();});
  $('[data-action="saved"]').addEventListener('click',()=>{state.savedOnly=!state.savedOnly;state.category='All';state.visible=36;render();$('#collection').scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});});
  $('.reset-filter').addEventListener('click',()=>{state.savedOnly=false;state.category='All';state.visible=12;render();});
  $('#diamond-choice').addEventListener('change',e=>{changeOrigin(e.target.value);toast(labels.origin_toast);});
  $('#detail-origin').addEventListener('change',e=>changeOrigin(e.target.value));
  $('#inquiry-origin').addEventListener('change',e=>{if(e.target.value!=='Compare both')changeOrigin(e.target.value);});
  function selectPhoto(index) {
    if(!state.active)return;
    const p=state.active,photos=p.images || [{url:p.image,view:'front'}],photo=photos[index];
    if(!photo)return;
    const video=$('[data-detail-video]'),img=$('[data-detail-image]'),stack=$('.detail-image-stack'),side=$('[data-detail-side]');
    video.pause();video.hidden=true;stack.hidden=false;img.src=photo.url;img.alt=p.name+' — '+(labels[photo.view]||labels.view_number);
    side.hidden=index!==0 || !p.sideImage;
    if(p.sideImage)side.src=p.sideImage;
    stack.dataset.hover=String(index===0 && !!p.sideImage);
    $('.detail-hover-note').hidden=index!==0 || !p.sideImage;
    root.querySelectorAll('[data-photo]').forEach(b=>b.setAttribute('aria-pressed',String(Number(b.dataset.photo)===index)));
    root.querySelectorAll('[data-media]').forEach(b=>b.setAttribute('aria-pressed','false'));
  }
  $('[data-gallery-thumbnails]').addEventListener('click',e=>{
    const photo=e.target.closest('[data-photo]');if(photo){selectPhoto(Number(photo.dataset.photo));return;}
    const button=e.target.closest('[data-media="video"]');if(!button || !state.active?.video)return;
    const video=$('[data-detail-video]');$('.detail-image-stack').hidden=true;$('.detail-hover-note').hidden=true;video.hidden=false;
    if(video.getAttribute('src')!==state.active.video)video.src=state.active.video;
    video.play().catch(()=>{});
    root.querySelectorAll('[data-photo]').forEach(b=>b.setAttribute('aria-pressed','false'));button.setAttribute('aria-pressed','true');
  });
  $('[data-detail-video]').addEventListener('error',()=>toast(labels.video_error));
  $('[data-detail-save]').addEventListener('click',()=>{if(state.active)toggleSave(state.active.id);});
  $('[data-detail-inquire]').addEventListener('click',()=>{
    state.inquiry=state.active.id;updateInquiry();changeOrigin($('#detail-origin').value);closePiece();history.replaceState(null,'','#inquire');$('#inquire').scrollIntoView({behavior:'instant'});setTimeout(()=>$('#DvahInquiry input[name="contact[name]"]').focus({preventScroll:true}),80);
  });
  $('[data-open-featured]').addEventListener('click',()=>openPiece('dvah-bracelet-bc2646'));
  const menu=$('.menu-toggle');menu.addEventListener('click',()=>{const open=menu.getAttribute('aria-expanded')!=='true';menu.setAttribute('aria-expanded',String(open));$('#mobile-nav').hidden=!open;});
  $('#mobile-nav').addEventListener('click',e=>{if(e.target.closest('a')){menu.setAttribute('aria-expanded','false');$('#mobile-nav').hidden=true;}});
  const film=$('#featured-film');
  if('IntersectionObserver' in window){new IntersectionObserver(es=>{if(!es[0].isIntersecting)film.pause();},{threshold:.15}).observe(film);}
  window.addEventListener('hashchange',()=>{if(location.hash.startsWith('#piece/'))openPiece(decodeURIComponent(location.hash.slice(7)),false);else if(dialog.open)closePiece();});
  fetch(root.dataset.catalogUrl).then(r=>{if(!r.ok)throw new Error('catalog');return r.json();}).then(data=>{
    state.pieces=data.pieces; saved=new Set([...saved].filter(id=>state.pieces.some(p=>p.id===id)));render();
    if(location.hash.startsWith('#piece/'))openPiece(decodeURIComponent(location.hash.slice(7)),false);
    if($('[data-inquiry-success]'))$('#inquire').scrollIntoView({behavior:'instant'});
  }).catch(()=>{ $('[data-result-count]').textContent=labels.error; });
})();
